module.exports = __webpack_public_path__ + "static/media/fr-ian.96e20cc6.jpg";